import { Modal } from 'antd';
import qbSignal from 'QuickBooking/signal';
import serviceAssets from 'QuickBooking/service-images';
import { IQuickBookingServiceItem } from 'services/types/quickBooking';
import { ModalBody, HeaderBar, HeaderTitle, HeaderClose, FooterBar } from './booking-history-styles';
import { Grid, ServiceCard, CardImg, CardName } from './add-services-styles';

type Props = {
  open: boolean;
  services: IQuickBookingServiceItem[];
  onClose: () => void;
  onToggle: (svc: IQuickBookingServiceItem) => void;
};

// Grid of all services (image + name); click toggles a service in the composer.
const AddServicesModal = ({ open, services, onClose, onToggle }: Props) => {
  const selectedNames = qbSignal.services.value.map((o) => String(o.label));

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      title={null}
      closable={false}
      closeIcon={null}
      width={560}
      centered
      styles={{ content: { padding: 0, borderRadius: 14, overflow: 'hidden' }, body: { padding: 0 } }}
    >
      <ModalBody>
        <HeaderBar>
          <HeaderTitle>SELECT SERVICES</HeaderTitle>
          <HeaderClose type="button" onClick={onClose}>
            Close
          </HeaderClose>
        </HeaderBar>

        <Grid>
          {services.map((svc) => {
            const isSelected = selectedNames.includes(svc.serviceName);
            const image = serviceAssets[svc.serviceName];
            return (
              <ServiceCard
                key={svc.id}
                type="button"
                $selected={isSelected}
                onClick={() => onToggle(svc)}
              >
                <CardImg>{image && <img src={image} alt="" />}</CardImg>
                <CardName $selected={isSelected}>{svc.serviceName}</CardName>
              </ServiceCard>
            );
          })}
        </Grid>

        <FooterBar type="button" onClick={onClose}>
          Xong
        </FooterBar>
      </ModalBody>
    </Modal>
  );
};

export default AddServicesModal;
